module.exports = __webpack_public_path__ + "img/search.2763f0f0.png";